<template>
  <div
    class="handle flex items-center w-base cursor-grab active:cursor-grabbing text-signableBrandColours-midGrey hover:text-signableBrandColours-darkGrey"
    :class="{ '!cursor-default !text-signableBrandColours-midGrey': disabled }"
  >
    <SixDotsIcon aria-hidden="true" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { SixDotsIcon } from '@/components/library/icons';

export default defineComponent({
  components: { SixDotsIcon },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
